export default "__VITE_ASSET__CFBN2RTw__"